<template>
  <div id='top'>
    <el-row>
      <el-col :span="4"><div class="grid-content bg-purple">&nbsp;</div></el-col>
      <el-col :span="16"><div class="grid-content bg-purple">Not connected</div></el-col>
      <el-col :span="4"><div class="grid-content bg-purple">&nbsp;</div></el-col>
    </el-row>
    <reconnect></reconnect>
  </div>
</template>

<script>
  import Reconnect from './reconnect'

  export default {
    name: 'not-connected',
    components: { Reconnect }
  }
</script>

<style scoped>
  #top {
    text-align: center;
    margin-top: 60px;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// not-connected.vue?72f5c5c2